<template>
	<svg
		width="99px"
		height="60px"
		viewBox="0 0 99 60"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="upload cloud icon"
	>
		<g
			id="Meetings"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Host---Upload-File"
				transform="translate(-1215.000000, -367.000000)"
				fill="#00DAB6"
			>
				<g id="Group" transform="translate(1115.000000, 15.000000)">
					<path
						d="M186.373401,388.032842 C187.599236,384.998105 188.280255,381.684842 188.280255,378.210526 C188.280255,363.734737 176.564204,352 162.111465,352 C152.104268,352 143.413076,357.628 139.010414,365.894105 C137.278229,364.329053 134.99114,363.368421 132.474522,363.368421 C127.076185,363.368421 122.700637,367.750947 122.700637,373.157895 C122.700637,373.373895 122.718924,373.585474 122.732796,373.797684 C121.597134,373.588632 120.428682,373.473684 119.232484,373.473684 C108.610478,373.473684 100,382.097895 100,392.736842 C100,403.375789 108.610478,412 119.232484,412 C119.33779,412 119.442465,411.993684 119.547771,411.991789 L119.547771,412 L148.021936,412 L148.001758,386.055368 L140.64486,392.665474 C139.596847,393.606526 138.000236,393.574316 136.990688,392.592211 C136.06879,391.694737 136.047981,390.218105 136.943395,389.294737 C136.98186,389.254316 137.022217,389.216421 137.063204,389.179158 L150.754841,376.947368 L164.50386,389.285263 C165.463592,390.146737 165.544936,391.624 164.684834,392.585895 C164.648261,392.626316 164.610427,392.666105 164.571331,392.704 C163.559892,393.686105 161.962019,393.714526 160.916529,392.769053 L153.494682,386.055368 C153.494682,386.055368 153.507293,400.512842 153.516752,412 L187.019108,412 C193.635713,412 199,406.627158 199,400 C199,393.372842 193.635713,388 187.019108,388 C186.80093,388 186.588427,388.020842 186.373401,388.032842 Z"
						id="Fill-1-Copy"
					/>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'UploadCloudActive',
}
</script>
